
import { useRef, useEffect } from "react";
import { BlogPost } from "@/types/blog";

interface UseInfiniteScrollLogicProps {
  posts: BlogPost[];
  loading: boolean;
  hasMore: boolean;
  loadingMore: boolean;
  fetchMore: () => void;
}

export const useInfiniteScrollLogic = ({
  posts,
  loading,
  hasMore,
  loadingMore,
  fetchMore
}: UseInfiniteScrollLogicProps) => {
  const loaderRef = useRef<HTMLDivElement>(null);

  // Set up intersection observer for infinite scrolling
  useEffect(() => {
    const currentLoader = loaderRef.current;
    if (!currentLoader) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && hasMore && !loading && !loadingMore) {
          console.log("Infinite scroll triggered, loading more posts");
          fetchMore();
        }
      },
      { 
        threshold: 0.1,
        rootMargin: '300px'
      }
    );
    
    observer.observe(currentLoader);
    
    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [fetchMore, hasMore, loading, loadingMore]);

  return { loaderRef };
};
